/**
 * Helper to easily configure our queries
 * @param fetchOnFocus If true, sets the  'refetchOnWindowFocus' prop to always
 * @param isEnabled The condition for the query to be enabled
 * @returns React Query config object.
 */
export const queryOptions = (
  fetchOnFocus: boolean,
  isEnabled: boolean,
  staleTime?: number,
  retryDelay?: number | ((attempt: number) => number),
) =>
  ({
    retry: (failureCount: number) => {
      if (failureCount > 5) return false;
      return true;
    },
    staleTime: staleTime ? staleTime : 1.1 * 60_000,
    retryDelay: retryDelay
      ? retryDelay
      : (attempt: number) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
    refetchOnMount: false,
    refetchOnWindowFocus: fetchOnFocus ? 'always' : false,
    enabled: isEnabled,
  } as any);
